const REPORT_TYPES = {
  productList: 'pl',
  productSummary: 'ps',
  assetList: 'al',
};

export default REPORT_TYPES;
